module.exports = __webpack_public_path__ + "media/customizations/valencia/back-cfaf16bdf616b51fce2a8279044417be.jpg";